"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectableContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _useSelectable = require("b2b-components/hooks/useSelectable");
var _Selectable = require("./Selectable");
const SelectableContainer = _ref => {
  let {
    defaultValue,
    isDisabled = false,
    isMultiple = true,
    onChange,
    render,
    value,
    className,
    label,
    markingType,
    text,
    error,
    info
  } = _ref;
  const {
    isOptionChecked,
    onOptionChange
  } = (0, _useSelectable.useSelectable)(defaultValue, value, onChange, isMultiple);
  return /*#__PURE__*/_react.default.createElement(_Selectable.Selectable, {
    className: className,
    error: error,
    info: info,
    label: label,
    markingType: markingType,
    text: text,
    onOptionChange: onOptionChange
  }, render({
    isDisabled: isDisabled || false,
    isOptionChecked,
    onOptionChange
  }));
};
exports.SelectableContainer = SelectableContainer;
//# sourceMappingURL=SelectableContainer.js.map